import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import {isMobile, MobileBreakpoint} from '../utils/MobileUtils';
import TimerController, { bindTimerStateEvents } from '../utils/TimerController';

export default class LoginPopupComponent extends Component {

  get SELECTORS() {
    return {
      textCloseBtn: "[data-text-close]",
      textContainer: "[data-text-container]",
      loginTogglerButton: "#loginTogglerButton",
      popupCloseBtn: "[data-popup-close]",
      loginPopup: "[data-login-popup]",
      accountIconLoginPopup: "[data-myaccount-login-popup]",
      loginPopupBackdrop: "[data-login-popup-backdrop]",
      loginPopupSpeechBubbleCta: "[data-login-speechbubble-cta]",

      // pwd recovery logic
      pwdRecoveryBtn: '[data-pwd-recovery-btn]',
      loginForm: '[data-login-form]',
      showLoginBtn: '[data-show-login-btn]',
      recoveryPasswordContainer: '[data-password-recovery]',
      recoveryPasswordForm: '#recoveryPwdForm',
      recoveryPasswordFormButton: '#recoveryPwdForm .custom-button',
      recoveryPasswordFormInput: '#recoveryPwdForm input[type="email"]',
      responseSuccess: '[data-mail-sent="true"]',
      responseSuccessWrapper: '[data-success-wrapper]',
      recoveryPasswordFormWrapper: '[data-form-wrapper]',
      responseFail: '[data-mail-sent="false"] .form-group',
      recoveryPasswordInput: 'input[type="email"]',
      recoveryPasswordBtn: 'button[type="submit"]'
    };
  }

  get CLASSES() {
    return {
      hidden: '--hidden',
      loading: '--loading'
    }
  }

  get COOKIE_NAME() {
    return {
      popupTextClose: 'login_popup_text_close',
      popupLoginClose: 'login_popup_close',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.loginPopupTimer = this.$component.dataset.loginPopupTimer ? this.$component.dataset.loginPopupTimer : 5000;
    this.loginFloatingIconTimer = this.$component.dataset.loginFloatingIconTimer ? this.$component.dataset.loginFloatingIconTimer : 5000;

    // TimerController: initial states
    this.layerStates = {
      menuOpen: false,
      newsletterOpen: false,
      searchOpen: false,
      lastTimerPaused: null,
    };
    this.timerController = null;
    this.floatingIconTimerController = null;
  }

  readDOM() {
    return {
      //popup constants
      loginPopupTimer: this.$component.dataset.loginPopupTimer ? this.$component.dataset.loginPopupTimer : 5000,
      loginFloatingIconTimer: this.$component.dataset.loginFloatingIconTimer ? this.$component.dataset.loginFloatingIconTimer : 5000,
      //elements
      textCloseBtn: this.$component.querySelector(this.SELECTORS.textCloseBtn),
      textContainer: this.$component.querySelector(this.SELECTORS.textContainer),
      popupCloseBtn: this.$component.querySelector(this.SELECTORS.popupCloseBtn),
      loginTogglerButton: this.$component.querySelector(this.SELECTORS.loginTogglerButton),
      loginPopup: this.$component.querySelector(this.SELECTORS.loginPopup),
      loginPopupBackdrop: this.$component.querySelector(this.SELECTORS.loginPopupBackdrop),
      loginPopupSpeechBubbleCta: this.$component.querySelector(this.SELECTORS.loginPopupSpeechBubbleCta),

      //my account icons
      accountIconLoginPopups: document.querySelectorAll(this.SELECTORS.accountIconLoginPopup),

      // pwd recovery
      pwdRecoveryBtn: this.$component.querySelector(this.SELECTORS.pwdRecoveryBtn),
      loginForm: this.$component.querySelector(this.SELECTORS.loginForm),
      showLoginBtn: this.$component.querySelector(this.SELECTORS.showLoginBtn),
      recoveryPasswordContainer: this.$component.querySelector(this.SELECTORS.recoveryPasswordContainer),
      recoveryPasswordForm: this.$component.querySelector(this.SELECTORS.recoveryPasswordForm),
      recoveryPasswordFormButton: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormButton),
      recoveryPasswordFormInput: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormInput),
      responseSuccessWrapper: this.$component.querySelector(this.SELECTORS.responseSuccessWrapper),
      recoveryPasswordFormWrapper: this.$component.querySelector(this.SELECTORS.recoveryPasswordFormWrapper),
    }
  }

  handlePopupTextClose() {
    //the cookie already exists, hide text section
    if (Cookies.get(this.COOKIE_NAME.popupTextClose)) {
      this.dom.textContainer.classList.add(this.CLASSES.hidden);
    }

    this.dom.textCloseBtn.addEventListener("click", event => {
      //set cookie
      Cookies.set(this.COOKIE_NAME.popupTextClose);
      //hide text container
      this.dom.textContainer.classList.add(this.CLASSES.hidden);
    });
  }

  handleLoginTogglerClick() {
    this.dom.loginPopupSpeechBubbleCta.addEventListener('click', () => {
      this.loginPopupOpen();
    });
    this.dom.loginTogglerButton.addEventListener("click", event => {
      this.loginPopupOpen();
    });
  }

  handleMyAccountClick() {
    if (this.dom.accountIconLoginPopups) {
      this.dom.accountIconLoginPopups.forEach(icon => {
        icon.addEventListener("click", event => {
          this.loginPopupOpen();
        });
      });
    }
  }

  loginPopupOpen() {
    this.dom.loginPopup.classList.add("--show");
    this.dom.loginPopupBackdrop.classList.remove(this.CLASSES.hidden);
    //hide text and button
    this.dom.textContainer.classList.add("--hidden");
    this.dom.loginTogglerButton.classList.add(this.CLASSES.hidden);

    // TimerController: Destroy timers when popup opens manually
    this.destroyTimers();

   //fire login open events
    this.$emit(this.$customEvents.LOGIN_POPUP_EVENTS.show);
  }

  loginPopupClose() {
    this.dom.popupCloseBtn.addEventListener("click", event => {
      Cookies.set(this.COOKIE_NAME.popupLoginClose);
      this.dom.loginPopup.classList.remove("--show");
      this.dom.loginPopupBackdrop.classList.add(this.CLASSES.hidden);

      // TimerController: Use TimerController for floating icon timer instead of setTimeout
      if (!Cookies.get(this.COOKIE_NAME.popupTextClose)) {
        this.floatingIconTimerController = new TimerController({
          delay: this.dom.loginFloatingIconTimer,
          shouldPauseFn: () => {
            const isAnyLayerOpen = Object.entries(this.layerStates)
              .filter(([key]) => key !== 'lastTimerPaused')
              .some(([_, state]) => state);
            const isMobileMenu = isAnyLayerOpen && isMobile(MobileBreakpoint.Max1023);
            return isAnyLayerOpen || isMobileMenu;
          },
          onComplete: () => {
            this.dom.textContainer.classList.remove(this.CLASSES.hidden);
            this.floatingIconTimerController = null;
          }
        });
        this.floatingIconTimerController.start();
      }

      this.dom.loginTogglerButton.classList.remove(this.CLASSES.hidden);

      //fire login close events
      this.$emit(this.$customEvents.LOGIN_POPUP_EVENTS.hide);
    });
  }

  // TimerController: Initialize login popup timer
  initializeLoginPopupTimer() {
    const loginPopupTimer = parseInt(this.loginPopupTimer) || 5000;
    const pageController = document?.documentElement?.dataset?.controller;

    if (!Cookies.get(this.COOKIE_NAME.popupLoginClose)) {
      this.timerController = new TimerController({
        delay: loginPopupTimer,
        shouldPauseFn: () => {
          const isAnyLayerOpen = Object.entries(this.layerStates)
            .filter(([key]) => key !== 'lastTimerPaused')
            .some(([_, state]) => state);
          const isMobileMenu = isAnyLayerOpen && isMobile(MobileBreakpoint.Max1023);
          const currentLayerState = isAnyLayerOpen || isMobileMenu;

          if (currentLayerState !== this.layerStates.lastTimerPaused) {
            /* Debug for Layer States
              console.log("TimerController: in LoginPopupComponent pause state changed", {
                isAnyLayerOpen,
                isMobileMenu,
                shouldPause: currentLayerState
              });
            */
            this.layerStates.lastTimerPaused = currentLayerState;
          }

          return currentLayerState;
        },
        /* TimerController: debug callbacks for timer events */
        /*
        onStart: (progress, remaining) => {
          console.info('TimerController: in LoginPopupComponent timer started', { progress, remaining });
        },
        onPause: (progress, remaining) => {
          console.info('TimerController: in LoginPopupComponent timer paused', { progress, remaining });
        },
        onResume: (progress, remaining) => {
          console.info('TimerController: in LoginPopupComponent timer resumed', { progress, remaining });
        },*/
        onComplete: () => {
         if (pageController === 'ListingController' || pageController === 'PdpController') {
            // In PLP/PDP mostro solo l’icona ridotta
            this.dom.loginTogglerButton.classList.remove(this.CLASSES.hidden);
            if (!Cookies.get(this.COOKIE_NAME.popupTextClose)) {
              this.dom.textContainer.classList.remove(this.CLASSES.hidden);
            }
          } else {
            this.loginPopupOpen();
          }
        }
      });

      this.timerController.start();
    } else {
      // TimerController: Use TimerController for floating icon timer
      this.floatingIconTimerController = new TimerController({
        delay: this.dom.loginFloatingIconTimer,
        shouldPauseFn: () => {
          const isAnyLayerOpen = Object.entries(this.layerStates)
            .filter(([key]) => key !== 'lastTimerPaused')
            .some(([_, state]) => state);
          const isMobileMenu = isAnyLayerOpen && isMobile(MobileBreakpoint.Max1023);
          return isAnyLayerOpen || isMobileMenu;
        },
        onComplete: () => {
          if (!Cookies.get(this.COOKIE_NAME.popupTextClose)) {
            this.dom.textContainer.classList.remove("--hidden");
          }
          this.dom.loginTogglerButton.classList.remove("--hidden");
          this.floatingIconTimerController = null;
        }
      });
      this.floatingIconTimerController.start();
    }
  }

  // TimerController: Handle timer state changes
  handleTimerStateChange() {
    if (this.timerController) {
      if (this.timerController.shouldPauseFn()) {
        this.timerController.pause();
      } else if (this.timerController.isPaused) {
        this.timerController.resume();
      }
    }

    if (this.floatingIconTimerController) {
      if (this.floatingIconTimerController.shouldPauseFn()) {
        this.floatingIconTimerController.pause();
      } else if (this.floatingIconTimerController.isPaused) {
        this.floatingIconTimerController.resume();
      }
    }
  }

  // TimerController: Destroy timers
  destroyTimers() {
    try {
      if (this.timerController) {
        this.timerController.destroy();
        this.timerController = null;
      }
    } catch (error) {
      console.error('TimerController: Error in LoginPopupComponent destroying timer controller:', error);
    }

    try {
      if (this.floatingIconTimerController) {
        this.floatingIconTimerController.destroy();
        this.floatingIconTimerController = null;
      }
    } catch (error) {
      console.error('TimerController: Error in LoginPopupComponent destroying floating icon timer controller:', error);
    }
  }
  // pwd recovery

  // PASSWORD RESET FORM HANDLING //
  toggleResetPasswordForm() {
    this.dom.recoveryPasswordContainer.classList.toggle(this.CLASSES.hidden);
    this.dom.loginForm.classList.toggle(this.CLASSES.hidden);
  }

  // hide/show pwdRecovery and pwdRecovery success msg
  togglePwdRecoverySuccess() {
    this.dom.responseSuccessWrapper.classList.toggle(this.CLASSES.hidden);
    this.dom.recoveryPasswordFormWrapper.classList.toggle(this.CLASSES.hidden);
  }

  // Should be a call to controller to reset the form, ok for now
  cleanPwdRecoveryForm() {
    if (this.dom.recoveryPasswordFormWrapper) {
      const form = this.dom.recoveryPasswordFormWrapper;

      if (form) {

        const input = form.querySelector(this.SELECTORS.recoveryPasswordInput);
        if (input) {
          input.value = '';
          input.parentElement.classList.remove('error');

          const formInput = form.querySelector('.form-group');
          const error = formInput?.querySelector('span.--msg-error');
          if (error) {
            formInput.removeChild(error);
          }
        }
        const btn = form.querySelector(this.SELECTORS.recoveryPasswordBtn);
        if (btn) {
          btn.classList.remove(this.CLASSES.loading);
        }

      }
    }
  }

  recoverPassword(event) {
    const ctx = this;

    event.preventDefault();
    const url = this.dom.recoveryPasswordForm.getAttribute('action');
    const form = new URLSearchParams(new FormData(this.dom.recoveryPasswordForm));

    ctx.manageSendFromLayer(true, true);
    ctx.readDOM().recoveryPasswordFormButton.classList.add(this.CLASSES.loading);

    fetch(url, {
      method: 'POST',
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: form
    })
      .then(res => {
        if (res.ok) {
          res.text().then(text => {
            const response = new DOMParser().parseFromString(text, 'text/html');
            // put response in page
            const responseSuccess = response.querySelector(ctx.SELECTORS.responseSuccess);
            const responseFail = response.querySelector(ctx.SELECTORS.responseFail);
            if (responseSuccess != null) {
              // toggle recovery form
              ctx.togglePwdRecoverySuccess();
              // replace html
              ctx.readDOM().responseSuccessWrapper.innerHTML = responseSuccess.innerHTML;
              // close layer on timer
              setTimeout(function () {
                ctx.manageSendFromLayer(false, false);
                ctx.toggleResetPasswordForm();
                ctx.togglePwdRecoverySuccess();
                ctx.cleanPwdRecoveryForm();
              }, 3000);
            }
            if (responseFail != null) {
              // replace html input
              const layerInput = ctx.readDOM().recoveryPasswordForm.querySelector('.form-group');
              ctx.readDOM().recoveryPasswordForm.replaceChild(responseFail, layerInput);
              ctx.readDOM().recoveryPasswordFormInput.value = '';
              // stop loading
              ctx.readDOM().recoveryPasswordFormButton.classList.remove(this.CLASSES.loading);
              // open layer, remove forced
              ctx.manageSendFromLayer(false, true);
            }
          })
        } else {
          console.error(res);
          ctx.manageSendFromLayer(false, true);
          ctx.readDOM().recoveryPasswordFormButton.classList.remove(this.CLASSES.loading);
        }
      })
      .catch(error => this.warn(error));
  }

  manageSendFromLayer(forceShow = false, focus = false) {
    forceShow ? this.$component.classList.add('--sending') : this.$component.classList.remove('--sending');

    if (this.readDOM().recoveryPasswordFormInput) {
      focus ? this.readDOM().recoveryPasswordFormInput.focus() : this.readDOM().recoveryPasswordFormInput.blur();
    }
  }

  handlePwdRecovery() {
    if(this.dom.pwdRecoveryBtn) {
      this.dom.pwdRecoveryBtn.addEventListener("click", () => this.toggleResetPasswordForm());
    }
    if(this.dom.showLoginBtn) {
      this.dom.showLoginBtn.addEventListener("click", () => this.toggleResetPasswordForm());
    }
    if(this.dom.recoveryPasswordForm) {
      this.dom.recoveryPasswordForm.addEventListener("submit", (event) => this.recoverPassword(event));
    }
  }

  // pwd recovery end

  initModalLogin() {
    // Check if there's the login error query parameter
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const loginError = urlParams.get('loginerror');
    //error in the login modal, show it
    if (`${loginError}` === 'true') {
      this.loginPopupOpen();
    } else {
      this.initializeLoginPopupTimer();
    }
  }

  bindEvents() {
    this.handlePopupTextClose();
    this.loginPopupClose();
    this.handleLoginTogglerClick();
    this.handleMyAccountClick();
    // pwd recovery
    this.handlePwdRecovery();

    // TimerController: Listen to layer state changes
    bindTimerStateEvents.call(this);

    // If Cookie banner is already accepted
    if (Cookies.get('cookies-disclaimer-v1')) {
      this.initModalLogin();
    } else {
      // Await Cookie banner accept event
      this.$on(this.$customEvents.COOKIE.accepted, () => {
        this.initModalLogin();
      });
    }
  }

  render() {
    this.dom = this.readDOM();
    this.bindEvents();
  }

  // TimerController: Override destroy method to clean up timers
  destroy() {
    this.destroyTimers();

    try {
      if (super.destroy && typeof super.destroy === 'function') {
        super.destroy();
      }
    } catch (error) {
      console.error('TimerController: Error in LoginPopupComponent calling parent destroy:', error);
    }
  }
}
